import React, {useState} from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components'
import { Checkbox } from 'antd';

import Layout from '../../components/Layout'
import Divider from '../../components/Divider'
import Button from '../../components/Button'
import Modal from '../../components/Modal'

import constants from '../../config/constants'
import citizen from '../../assets/images/citizen.svg'

const Main = styled.div`
  padding-top: 2rem;
`

const MainImg = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  padding-top: 2rem;
`
const Bullet = styled.p`
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
  padding: 0 0.5rem;
`
const CheckboxStyled = styled(Checkbox)`
  font-family: 'Thonburi';
  font-size: 14px !important;
  line-height: 18.9px !important;
  color: ${constants.color.mediumDark} !important;
  margin: 1rem 0 !important;

  .ant-checkbox-inner {
    width: 24px !important;
    height: 24px !important;
    border-radius: 4px;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${constants.color.darkBlue};
    border: none !important;

    &::after {
      border: 1.5px solid ${constants.color.white} !important;
      top: 55% !important;
      left: 30% !important;
      width: 5px !important;
      border-top: 0 !important;
      border-left: 0 !important;
      height: 10px !important;
      transform: rotate(45deg) scale(1.5) translate(-50%, -50%) !important;
    }
  }
`

const MainModal = styled.div`
  text-align: center;
`

const ModalDetail = styled.p`
  color: ${constants.color.mediumDark};
`


const Fatca = (props) => {

  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <Layout title={'ตรวจสอบคุณสมบัติ'} backIcon={true} onClick={() => props.history.push('/')}>
      <Main>
        <MainImg>
          <LazyLoadImage
            alt=''
            height={150}
            src={citizen}
            visibleByDefault={true}
            width={150} />
        </MainImg>
        <MainDetail>
          <Bullet>ไม่ถือสัญชาติอเมริกัน</Bullet>
          <Bullet>ไม่ได้ถือบัตรประจำตัวผู้มีถิ่นที่อยู่ถาวรอย่างถูกต้องในสหรัฐอเมริกา เช่น กรีนการ์ด เป็นต้น</Bullet>
          <Bullet>ไม่ได้ถือบัตรประจำตัวผู้มีถิ่นที่อยู่ถาวรอย่าง เพื่อวัตถุประสงค์ในการเก็บภาษีอากรของสหรัฐอเมริกา</Bullet>
          <Divider/>
          <Bullet>ไม่เคยมีประวัติกระทําความผิดฐานฟอกเงิน</Bullet>
          <Bullet>ไม่เป็นนักการเมือง และไม่มีความเกี่ยวข้องกับนักการเมือง หรือบุคคลที่มีสถานภาพทางการเมือง</Bullet>
          <Bullet>ไม่เคยถูกปฏิเสธการรับทำธุรกรรมทางการเงินจากสถาบันทางการเงินอื่น</Bullet>
          <CheckboxStyled size='big' checked={checked} onChange={() => setChecked(!checked)} >
            ข้าพเจ้ายืนยันข้อมูลข้างต้น
          </CheckboxStyled>
        </MainDetail>
        <Button
          textcolor={'#fff'}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ยืนยัน'}
          disabled={false}
          onClick={() => {checked ? props.history.push('/on-boarding-stage') : setOpenModal(!openModal) }}/>
      </Main>
      <Modal visible={openModal}>
        <MainModal>
          <h4>ขออภัยไม่สามารถเปิดบัญชีได้</h4>
          <ModalDetail>เนื่องจากคุณมีคุณสมบัติที่ไม่สามารถ<br/>เปิดบัญชีลงทุนกับ บลน.แอสเซนต์ เวลธ์ ได้</ModalDetail>
          <Button
            textcolor={'#fff'}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ตกลง'}
            disabled={false}
            onClick={() => setOpenModal(!openModal)}/>
        </MainModal>
      </Modal>
    </Layout>
  )
}

export default Fatca
